module.exports = __webpack_public_path__ + "assets/img/01.cd336c71.png";